import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  closeButton: { marginLeft: '8px', '& .MuiSvgIcon-root': { marginRight: '0px' } },
  dialogPaper: { margin: 'auto' },
  dialogContent: {},
  formLabel: { marginBottom: '4px', fontSize: '16px', fontWeight: foundations.typography.fontWeight.medium },
  dialogActions: { justifyContent: 'flex-end', gap: '8px', padding: '16px 24px' },
  centeredContent: { display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '16px 0' },
  successIcon: { fontSize: '64px', color: foundations.colors.green500 },
  failureIcon: { fontSize: '64px', color: foundations.colors.red600 },
});
